import type { TMessage } from '@stores/chat-domain.types';

/** Retorna as mensagens desde o último lead (mensagem com `detail`), em ordem cronológica. */
export const getMessagesFromLastLead = (messages: TMessage[]): TMessage[] => {
	const reversed = [...messages].reverse();
	const lastLeadIndex = reversed.findIndex(({ detail }) => !!detail);
	if (lastLeadIndex === -1) return [];
	return reversed.slice(0, lastLeadIndex + 1).reverse();
};

/** Retorna as mensagens a partir da primeira resposta do vendedor (mensagem não-minha). */
export const getMessagesFromFirstVendorResponse = (messages: TMessage[]): TMessage[] => {
	const firstVendorIndex = messages.findIndex(msg => !msg.itsMyMessage);
	return firstVendorIndex === -1 ? [] : messages.slice(firstVendorIndex);
};

export const countMyMessages = (messages: TMessage[]): number =>
	messages.filter(msg => msg.itsMyMessage).length;
